import { ClaimStatus } from '../../../../../../shared/constants/claim-status.enum';

export interface IClaimHistoryStatistics {
  uploadId: string;
  uploadName: string;
  uploadDate: string;
  claimUploadHistoryDetailsByStatus: IClaimUploadHistoryDetailsByStatus[];
}

export interface IClaimUploadHistoryDetailsByStatus {
  status: ClaimStatus;
  totalClaim: number;
  totalNet: number;
}

export interface IClaimUploadHistoryDetailList {
  uploadId: string;
  sectionName: string;
  fieldName: string;
  errorCount: number;
  status: number;
  type?: ClaimStatus;
  ratio: number;
}
export interface IClaimUploadHistorySummaryList {
  uploadId: string;
  providerApprovalNo: string;
  approvalRequestId: string;
  referenceNo: string;
  status: number;
  approvalType: number;
  sectionName: string;
  fieldName: string;
  errorMessage: string;
  dateOrdered: string;
  patientFileNo: string;
}

export interface IUploadHistoryList {
  uploadId: string,
  uploadName: string,
  totalClaims: number,
  readyforSubmission: number,
  validationErrors: number,
  notUploaded: number,
  createdDate: string
}

export const claimHistoryConfig = {
  entityName: 'CLAIM.CLAIM_SUMMARY.TITLE'
};